import React, { useEffect } from "react";
import { Autocomplete, Button, Grid, Paper, Toolbar } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import CommonForm from "../../utils/components/commonForm";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";

const EditCompetentMaster = () => {
  const [inputStates, setInputStates] = React.useState({});
  const params = useParams();

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const handleSubmit = () => {
    let url = BASE_URL;
    if (params.id) {
      axiosWithToken
        .patch(url + `competents/${params.id}`, inputStates)
        .then((res) => {
          setTimeout(refresh, 500);
          toast("Competent edit successfully !");
        })
        .catch((error) => {
          toast.error("Something Went Wrong!");
        });
    } else {
      axiosWithToken
        .post(url + "competents", inputStates)
        .then((res) => {
          setTimeout(refresh, 500);
          toast("Competent created successfully !");
        })
        .catch((error) => {
          toast.error("Something Went Wrong!");
        });
    }
  };

  const fetchCompetents = (inpt) => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `competents/${params.id}`)
      .then((res) => {
        let dataObject = res.data[0];

        let newData = {
          ...inputStates,
          ...dataObject,
        };
        dataObject && setInputStates(newData);
      })
      .catch((error) => {
        toast.error("Something Went Wrong!");
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    if (params.id) fetchCompetents();
  }, [params.id]);

  const inputFields = [

    { type: "TextField", label: "Competent Name", stateKey: "personName" },
    { type: "TextField", label: "Qualification", stateKey: "qualification" },
    { type: "TextField", label: "Address ", stateKey: "address" },
    { type: "TextField", label: "Taluka", stateKey: "taluka" },
    { type: "TextField", label: "District", stateKey: "district" },
    { type: "TextField", label: "Email", stateKey: "email" },
    { type: "TextField", label: "Contact Number", stateKey: "contactNumber" },
    { type: "TextField", label: "CPC Number", stateKey: "cpcNumber" },
  ];

  return (
    <>
      <Paper sx={{ mt: 2, p: 4 }}>
        <CommonForm
          inputStates={inputStates}
          updateInputObject={updateInputObject}
          inputFields={inputFields}
        />

        <Toolbar
          style={{
            padding: "0px",
            overflow: "auto",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            onClick={() => {
              handleSubmit();
            }}
          >
            {params.id ? "Update" : "Save"}
          </Button>
        </Toolbar>
      </Paper>
    </>
  );
};

export default EditCompetentMaster;
